/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_seller = {
    readonly trackedPhone: {
        readonly phoneNumber: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactButton_seller" | "StorefrontCallButton_seller" | "StorefrontSocialShare_seller">;
    readonly " $refType": "StorefrontSocial_seller";
};
export type StorefrontSocial_seller$data = StorefrontSocial_seller;
export type StorefrontSocial_seller$key = {
    readonly " $data"?: StorefrontSocial_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontSocial_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Phone",
      "kind": "LinkedField",
      "name": "trackedPhone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontContactButton_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontSocialShare_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '37599e40e9e9137722e3543f09cb3b86';
export default node;
